import i18n from "i18next";
import { atom } from 'recoil';
import { LOCAL_STORAGE_CURRENT_LOCALE_CODE } from "../../Constants/common";

export const CurrentLocaleCode = atom({
    key: 'CurrentLocaleCode',
    default: window.localStorage.getItem(LOCAL_STORAGE_CURRENT_LOCALE_CODE) || i18n.options.fallbackLng,
});
